import gql from 'graphql-tag';

export default gql`
    query GetAllStatusFilter {
        getAllStatusFilter {
            id
            name
        }
    }
`;
